const DEFAULT_WEIGHT = 100;
export const pickRandom = (options) => {
    const totalWeight = options.reduce((total, item) => {
        if (Array.isArray(item)) {
            return total + item[1];
        }
        return total + DEFAULT_WEIGHT;
    }, 0);
    const randomNum = Math.floor(Math.random() * totalWeight);
    let count = 0;
    let lastItem;
    for (let i = 0; i < options.length; i++) {
        if (count > randomNum)
            break;
        lastItem = Array.isArray(options[i]) ? options[i][0] : options[i];
        const itemWeight = Array.isArray(options[i]) ? options[i][1] : DEFAULT_WEIGHT;
        count += itemWeight;
    }
    return lastItem;
};
